import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=67bfbfa2&scoped=true&"
import script from "./SelectType.vue?vue&type=script&lang=js&"
export * from "./SelectType.vue?vue&type=script&lang=js&"
import style0 from "./SelectType.vue?vue&type=style&index=0&id=67bfbfa2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bfbfa2",
  null
  
)

export default component.exports